import { createSlice } from '@reduxjs/toolkit';
import * as actions from './actions';

const authSlice = createSlice({
	name: 'auth',
	initialState: {
		loading: false,
		token: null,
        refreshToken: null,
		displayName: '',
		email: '',
        siteUserId: '',
        isAuthenticated: false,
	},
	reducers: {
		logoutUser(state) {	
			state.loading = false;
			state.token = null;
			state.refreshToken = null;
			state.displayName = '';	
            state.email = '';	
            state.siteUserId = '';
            state.isAuthenticated= false;
		}
	},
	extraReducers: (builder) => {
		// User Login
		builder.addCase(actions.userLogin.pending, state => {
			state.loading = true;
		})
		builder.addCase(actions.userLogin.fulfilled, (state, action) => {
			if (action.payload.success) {				
				const { token, displayName, refreshToken, email, siteUserId  } = action.payload.data || {};		
				state.token = token;
				state.refreshToken = refreshToken;
				state.displayName = displayName;	
                state.email = email;	
                state.siteUserId = siteUserId;
                state.isAuthenticated= true;			
		
            } else {
                state.token = null;
                state.refreshToken = null;
                state.displayName = '';
                state.email = '';
                state.siteUserId = '';
                state.isAuthenticated= false;
            }
			state.loading = false;
		})
		builder.addCase(actions.userLogin.rejected, state => {
            state.loading = false;
            state.token = null;
            state.refreshToken = null;
            state.displayName = '';
            state.email = '';
            state.siteUserId = '';
            state.isAuthenticated = false;
		})

		builder.addCase(actions.getNewToken.pending, state => {
			state.loading = true;
		})
		builder.addCase(actions.getNewToken.fulfilled, (state, action) => {
			const { token } = action.payload.data || {};
			state.token = token;
			state.loading = false;
		})
		builder.addCase(actions.getNewToken.rejected, state => {
			state.loading = false;
            state.token = null;
            state.refreshToken = null;
            state.displayName = '';
            state.email = '';
            state.siteUserId = '';
            state.isAuthenticated= false;
		})
	}
});

export const { logoutUser } = authSlice.actions

export default authSlice.reducer;
